import useSWR from "swr";

export const useFetchTodaysKuchikomyuOverallScoresCount = (restaurantId: string) => {
  const { data: todaysKuchikomyuOverallScoresCount, error, isLoading } = useSWR<number>(`kuchikomyu/overall-scores/today/count/?restaurantId=${restaurantId}`)
  return { todaysKuchikomyuOverallScoresCount, isLoading, error };
};